module.exports = __webpack_public_path__ + "static/media/RoundTableLogo.b660e870.png";